// extracted by mini-css-extract-plugin
export default {"uploadQueuePopover":"UploadQueue_uploadQueuePopover__pTR02"};